module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "profiles"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("My Profiles "), (_vm.is_external) ? _c('small', [_vm._v("View profile details")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pull-right btn btn-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "/profiles/create"
    }
  }, [_vm._v("Create Profile")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', [_vm._v("Profiles let you link multiple email addresses with your account, allowing you to log in with any linked email address.")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "profile_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.profile_options,
      "dtHeaders": _vm.profile_headers
    }
  })], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fb57170"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/profile_dashboard.vue
// module id = 937
// module chunks = 0